{
  "types": {
    "ASSET": "أصول",
    "LIABILITY": "خصوم",
    "EQUITY": "حقوق ملكية",
    "REVENUE": "إيرادات",
    "EXPENSE": "مصروفات"
  },
  "fields": {
    "code": "الرمز",
    "name": "الاسم",
    "nameAr": "الاسم بالعربية",
    "type": "النوع",
    "parent": "الحساب الرئيسي",
    "isPostable": "يمكن الترحيل إلى هذا الحساب",
    "roles": "يُستخدم لـ"
  },
  "leave": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
    "confirm": "تجاهل التغييرات",
    "cancel": "متابعة التعديل"
  },
  "errors": {
    "SYSTEM_ACCOUNT": "هذا حساب نظام: لا يتغير نوعه ولا إعداد الترحيل إليه، ولا يمكن أرشفته.",
    "ACCOUNT_HAS_POSTINGS": "لهذا الحساب قيود بالفعل، لذا لم يعد بالإمكان تغيير نوعه أو إعداد الترحيل إليه.",
    "ACCOUNT_HAS_CHILDREN": "لهذا الحساب حسابات فرعية. أرشفها أو انقلها أولًا.",
    "ACCOUNT_IN_USE": "هذا الحساب مربوط بدور محاسبي. اختر حسابًا آخر لذلك الدور أولًا (ربط الحسابات).",
    "TREASURY_GL_ACCOUNT": "هذا الحساب تابع لحساب نقدية أو بنك، لذا يبقى كما هو. أرشِف حساب النقدية أو البنك من صفحة النقدية والبنوك بدلًا من ذلك.",
    "TILL_DRAWER_ACCOUNT": "هذا الحساب النقدي هو درج الصندوق {{tills}}: أدخِل النقد إليه أو أخرِجه منه في الصندوق (إيداع / سحب نقدي)، أو اختر حسابًا آخر.",
    "DRAWER_SHIFT_OPEN": "الوردية {{shifts}} مفتوحة على الصندوق {{tills}}، وهذا الإجراء يحرّك درجه. استخدم الإيداع أو السحب النقدي في الصندوق، أو انتظر حتى تُغلق الوردية.",
    "PERIOD_CLOSED": "السنة المالية لهذا التاريخ مغلقة. اختر تاريخًا في سنة مفتوحة.",
    "NO_FISCAL_YEAR": "لا توجد سنة مالية تشمل هذا التاريخ. أنشئ السنة المالية أولًا.",
    "CANNOT_REVERSE_REVERSAL": "لا يمكن عكس قيد عكسي.",
    "REVERSAL_BEFORE_ORIGINAL": "لا يمكن أن يسبق تاريخ القيد العكسي تاريخ القيد الأصلي.",
    "ACCOUNT_ROLE_NOT_CONFIGURED": "لم يُحدَّد حساب لدور محاسبي مطلوب. حدّده في ربط الحسابات.",
    "INVALID_POSTING": "لا يمكن ترحيل القيد كما هو. راجع الحسابات والمبالغ في كل سطر."
  },
  "chart": {
    "title": "دليل الحسابات",
    "subtitle": "الحسابات التي تُرحَّل إليها القيود، مجمّعة تحت الحسابات الرئيسية.",
    "new": "حساب جديد",
    "newTitle": "حساب جديد",
    "newSubtitle": "أضف حساب ترحيل، أو حسابًا رئيسيًا تُجمَّع تحته الحسابات.",
    "editTitle": "تعديل الحساب",
    "save": "حفظ الحساب",
    "actions": "إجراءات",
    "header": "حساب رئيسي ({{type}})",
    "archived": "مؤرشف",
    "systemAccount": "حساب نظام",
    "systemNotice": "هذا حساب نظام. يمكنك تغيير اسمه، أما نوعه وإعداد الترحيل إليه فثابتان.",
    "searchLabel": "البحث في الحسابات",
    "searchPlaceholder": "ابحث بالرمز أو الاسم…",
    "clearSearch": "مسح البحث",
    "showArchived": "إظهار المؤرشفة",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل",
    "addUnder": "إضافة حساب تحت {{name}}",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "restoreNamed": "استعادة {{name}}",
    "searchAccounts": "ابحث بالرمز أو الاسم…",
    "noAccounts": "لا توجد حسابات.",
    "noHeaders": "لا توجد حسابات رئيسية من هذا النوع.",
    "noParent": "بلا حساب رئيسي (المستوى الأعلى)",
    "clearParent": "النقل إلى المستوى الأعلى",
    "hints": {
      "type": "يحدد الجانب الذي يزيد عليه الحساب وموقعه في التقارير.",
      "systemType": "تحتفظ حسابات النظام بنوعها.",
      "parent": "لا تضم الحسابات الفرعية إلا حسابات رئيسية من النوع نفسه.",
      "postable": "حساب ترحيل: يمكن استخدامه في سطور القيود.",
      "header": "حساب رئيسي: يجمّع الحسابات الفرعية ويجمع أرصدتها في التقارير فقط."
    },
    "errors": {
      "codeTaken": "يوجد حساب آخر بهذا الرمز.",
      "parent": "اختر حسابًا رئيسيًا من النوع نفسه.",
      "version": "عدّل شخص آخر هذا الحساب. أغلق هذه اللوحة وافتح الحساب مرة أخرى."
    },
    "archive": {
      "title": "أرشفة الحساب {{code}}؟",
      "body": "لن يعود بالإمكان الترحيل إليه. يبقى تاريخه في التقارير، ويمكنك استعادته لاحقًا.",
      "confirm": "أرشفة"
    },
    "restore": {
      "title": "استعادة الحساب {{code}}؟",
      "body": "يمكن الترحيل إليه مرة أخرى.",
      "confirm": "استعادة"
    },
    "toast": {
      "created": "تم إنشاء الحساب {{code}}",
      "updated": "تم حفظ الحساب",
      "archived": "تمت أرشفة الحساب",
      "restored": "تمت استعادة الحساب"
    },
    "empty": {
      "title": "لا توجد حسابات بعد.",
      "filtered": "لا توجد حسابات مطابقة.",
      "filteredBody": "جرّب رمزًا أو اسمًا آخر."
    }
  },
  "mapping": {
    "title": "ربط الحسابات",
    "subtitle": "الحساب الذي يستخدمه كل نوع من الترحيلات. تُرحِّل المستندات إلى هذه الحسابات تلقائيًا.",
    "role": "يُستخدم لـ",
    "expectedType": "نوع الحساب",
    "account": "الحساب",
    "accountFor": "حساب {{role}}",
    "choose": "اختر حسابًا",
    "search": "ابحث بالرمز أو الاسم…",
    "noAccounts": "لا توجد حسابات ترحيل نشطة من نوع {{type}}.",
    "notMapped": "لم يُختر حساب",
    "none": "لا توجد أدوار للربط.",
    "save": "حفظ الربط",
    "saved": "تم حفظ ربط الحسابات",
    "unmappedTitle_zero": "لا توجد أدوار بلا حساب",
    "unmappedTitle_one": "دور واحد بلا حساب",
    "unmappedTitle_two": "دوران بلا حساب",
    "unmappedTitle_few": "{{n}} أدوار بلا حساب",
    "unmappedTitle_many": "{{n}} دورًا بلا حساب",
    "unmappedTitle_other": "{{n}} دور بلا حساب",
    "unmappedBody": "لا يمكن ترحيل المستندات التي تحتاج هذه الأدوار حتى يُحدَّد حساب لكل منها.",
    "pending_zero": "لا توجد تغييرات",
    "pending_one": "تغيير واحد غير محفوظ",
    "pending_two": "تغييران غير محفوظين",
    "pending_few": "{{n}} تغييرات غير محفوظة",
    "pending_many": "{{n}} تغييرًا غير محفوظ",
    "pending_other": "{{n}} تغيير غير محفوظ",
    "errors": {
      "rows": "بعض الحسابات لا يمكن استخدامها. راجع السطور المحددة.",
      "invalid": "اختر حساب ترحيل نشطًا من النوع الصحيح."
    }
  },
  "journals": {
    "title": "القيود اليومية",
    "subtitle": "كل ترحيل إلى دفتر الأستاذ، اليدوي منها والناتج عن المستندات.",
    "new": "قيد يومية جديد",
    "newTitle": "قيد يومية جديد",
    "newSubtitle": "قيد يدوي: يجب أن يساوي المدين الدائن.",
    "post": "ترحيل القيد",
    "saveHint": "اضغط {{shortcut}} للترحيل",
    "kindFilter": "التصفية حسب النوع",
    "allKinds": "كل الأنواع",
    "accountFilter": "التصفية حسب الحساب",
    "allAccounts": "كل الحسابات",
    "clearFilters": "مسح عوامل التصفية",
    "lines": "السطور",
    "linesHint": "سطران على الأقل. لكل سطر مبلغ مدين أو دائن.",
    "lineActions": "إجراءات السطر",
    "addLine": "إضافة سطر",
    "removeLine": "حذف السطر {{n}}",
    "enterHint": "اضغط Enter في السطر الأخير لإضافة سطر آخر.",
    "chooseAccount": "اختر حسابًا",
    "accountOfLine": "الحساب، السطر {{n}}",
    "descriptionOfLine": "الوصف، السطر {{n}}",
    "debitOfLine": "مدين، السطر {{n}}",
    "creditOfLine": "دائن، السطر {{n}}",
    "totals": "المجاميع",
    "difference": "الفرق",
    "balanced": "متوازن",
    "outOfBalance": "غير متوازن بمقدار",
    "reversedTitle": "عُكس هذا القيد",
    "reversedBy": "عُكس بالقيد",
    "reversalOf": "هذا القيد يعكس",
    "sections": {
      "entry": "القيد"
    },
    "fields": {
      "number": "الرقم",
      "date": "التاريخ",
      "kind": "النوع",
      "reference": "المرجع",
      "description": "البيان",
      "total": "الإجمالي",
      "status": "الحالة",
      "account": "الحساب",
      "lineDescription": "وصف السطر",
      "debit": "مدين",
      "credit": "دائن",
      "source": "المصدر",
      "postedAt": "تاريخ الترحيل"
    },
    "kind": {
      "MANUAL": "يدوي",
      "SYSTEM": "من مستند",
      "REVERSAL": "عكسي",
      "OPENING": "رصيد افتتاحي",
      "CLOSING": "إقفال نهاية السنة"
    },
    "status": {
      "POSTED": "مرحّل",
      "REVERSED": "معكوس"
    },
    "source": {
      "Expense": "مصروف",
      "TreasuryTransfer": "تحويل نقدي أو بنكي",
      "TreasuryAccount": "رصيد افتتاحي لحساب نقدي أو بنكي",
      "Purchase": "فاتورة شراء",
      "SupplierPayment": "دفعة لمورد",
      "SupplierReturn": "مرتجع مورد",
      "CustomerRefund": "مبلغ مسترد لعميل",
      "PosSale": "بيع من نقطة البيع",
      "PosShift": "وردية صندوق (زيادة أو عجز نقدي)",
      "SupplierRefund": "مبلغ مسترد من مورد",
      "BankStatement": "التسوية البنكية"
    },
    "empty": {
      "title": "لا توجد قيود بعد.",
      "body": "رحّل قيدًا يدويًا، أو سجّل مستندات تُرحَّل تلقائيًا.",
      "filteredTitle": "لا توجد قيود مطابقة.",
      "filteredBody": "جرّب فترة أو نوعًا أو حسابًا آخر، أو امسح عوامل التصفية."
    },
    "errors": {
      "notPosted": "لم يُرحَّل القيد",
      "unbalanced": "يجب أن يتساوى المدين ({{debit}}) والدائن ({{credit}}) وأن يكونا أكبر من صفر."
    },
    "toast": {
      "posted": "تم ترحيل القيد {{number}}"
    },
    "reverse": {
      "action": "عكس القيد",
      "title": "عكس القيد {{number}}؟",
      "body": "يُنشأ قيد جديد تتبادل فيه المبالغ المدينة والدائنة فيُبطِل أثر هذا القيد. يبقى القيدان في الدفاتر.",
      "reason": "السبب",
      "date": "تاريخ القيد العكسي",
      "dateHint": "في {{date}} (تاريخ القيد) أو بعده.",
      "confirm": "عكس القيد",
      "done": "تم ترحيل القيد العكسي {{number}}",
      "already": "عُكس هذا القيد من قبل. أعد التحميل لعرض القيد العكسي."
    },
    "stats": {
      "label": "أرقام القيود",
      "posted": "المرحّل هذا الشهر",
      "postedDetail": "{{month}} · {{entries}}",
      "trend": "قيود اليومية حسب الشهر، من {{from}} إلى {{to}}",
      "manual": "القيود اليدوية",
      "system": "من المستندات",
      "reversals": "القيود العكسية",
      "totalDetail": "{{amount}} إجمالًا",
      "entries_zero": "لا قيود",
      "entries_one": "قيد واحد",
      "entries_two": "قيدان",
      "entries_few": "{{n}} قيود",
      "entries_many": "{{n}} قيدًا",
      "entries_other": "{{n}} قيد"
    }
  },
  "trialBalance": {
    "title": "ميزان المراجعة",
    "account": "الحساب",
    "opening": "الرصيد الافتتاحي",
    "period": "الحركة",
    "closing": "الرصيد الختامي",
    "debit": "مدين",
    "credit": "دائن",
    "totals": "المجاميع",
    "hideZero": "إخفاء الحسابات بلا أرصدة",
    "balanced": "المدين يساوي الدائن",
    "unbalanced": "غير متوازن بمقدار {{amount}}",
    "empty": "لا توجد ترحيلات في هذه الفترة.",
    "emptyBody": "اختر فترة أخرى، أو أوقف «إخفاء الحسابات بلا أرصدة».",
    "invalidRange": "تاريخ النهاية قبل تاريخ البداية.",
    "printedAt": "طُبع في {{at}}",
    "hint": "المبالغ بالريال العماني. اختر حسابًا لعرض قيوده في الفترة. اليوم هو {{today}}."
  },
  "fiscalYears": {
    "title": "السنوات المالية",
    "subtitle": "الفترات التي تُرحَّل فيها القيود. يجب أن يقع تاريخ كل قيد في سنة مفتوحة.",
    "new": "سنة مالية جديدة",
    "newTitle": "سنة مالية جديدة",
    "newSubtitle": "عادةً السنة التي تلي آخر سنة.",
    "save": "إنشاء السنة المالية",
    "current": "الحالية",
    "hint": "لا يجوز أن تتداخل السنوات المالية. إن لم توجد سنة، تُنشأ سنة ميلادية تلقائيًا عند ترحيل أول قيد فيها.",
    "fields": {
      "name": "الاسم",
      "startDate": "تبدأ",
      "endDate": "تنتهي",
      "status": "الحالة"
    },
    "status": {
      "OPEN": "مفتوحة",
      "CLOSED": "مغلقة"
    },
    "empty": {
      "title": "لا توجد سنوات مالية بعد.",
      "body": "تُنشأ السنوات الميلادية تلقائيًا مع أول قيد في كل سنة. أنشئ سنة هنا لاستخدام سنة مالية مختلفة."
    },
    "errors": {
      "overlap": "هذه الفترة تتداخل مع سنة مالية موجودة.",
      "endBeforeStart": "يجب أن يكون تاريخ النهاية بعد تاريخ البداية."
    },
    "toast": {
      "created": "تم إنشاء {{name}}"
    }
  }
}
